import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

// prevent to close modal on outside click
export const MODAL_WITHOUT_BACKDROP_OPTION: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false
};

export const DESIGN_PREVIEW_STATE: string = 'design_preview_state';
export const DESIGN_PREVIEW_MODAL_ID: string = 'design_preview_modal_id';
